module.exports = __webpack_public_path__ + "static/media/button_close.35c88634.png";